import GeoJSON from 'ol/format/GeoJSON';
import React from 'react';
import {Trans} from 'react-i18next';
import {connect} from 'react-redux';
import {object, string} from 'prop-types';

import formatDistance, {localizationMap} from '@explorer/util/format-distance';
import {getDistanceUnits} from '@explorer/selectors/measurements';

const LengthIndicator = ({geometry, units}) => {
  if (!geometry) {
    return '';
  } else {
    const olGeom = new GeoJSON().readGeometry(geometry);
    const distance = formatDistance(olGeom, units, '0,0[.]000', {
      projection: 'EPSG:4326',
    });
    return localizationMap[units] ? (
      <Trans i18nKey={localizationMap[units]} values={{distance}} />
    ) : null;
  }
};

LengthIndicator.propTypes = {
  geometry: object,
  units: string.isRequired,
};

const mapStateToProps = state => ({
  units: getDistanceUnits(state),
});

export default connect(mapStateToProps)(LengthIndicator);
